import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import { PageLoader, EmptyState } from "@/components/Loading";
import { CalendarCheck } from "lucide-react";
import { ActivityCard } from "@/pages/Activities";

export default function MyActivities() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/activities/mine").then((r) => setItems(r.data)).catch(() => setItems([])); }, []);
  if (items === null) return <PageLoader />;
  return (
    <>
      <PageHeader title="أنشطتي" subtitle="الأنشطة التي سجّلت فيها" />
      {items.length === 0 ? <EmptyState icon={CalendarCheck} title="لم تسجّل في أي نشاط بعد" desc="تصفّح صفحة الأنشطة وشارك فيما يناسبك." /> : (
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((a) => (
            <ActivityCard key={a.id} a={a}>
              <p className={`mt-3 border-t border-slate-100 pt-3 text-xs font-semibold ${a.reg_status === "waitlist" ? "text-amber-600" : "text-emerald-600"}`}>{a.reg_status === "waitlist" ? "⏳ أنت في قائمة الانتظار" : "✓ أنت مسجّل في هذا النشاط"}</p>
            </ActivityCard>
          ))}
        </div>
      )}
    </>
  );
}
